import React from "react";
import PropTypes from "prop-types";
import { Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

export default function VoteCounter(props) {
  let style = { fontSize: "150%" };
  return (
    <Container>
      <Row>
        <OverlayTrigger
          key={`upvote-${props.id}`}
          placement="right"
          overlay={<Tooltip id={`upvote-${props.id}-tooltip`}>Helpful</Tooltip>}
        >
          <i className="fas fa-caret-up" onClick={onClickUpVote} style={style} />
        </OverlayTrigger>
      </Row>
      <Row>
        <strong style={style}>{props.voteCount}</strong>
      </Row>
      <Row>
        <OverlayTrigger
          key={`downvote-${props.id}`}
          placement="right"
          overlay={<Tooltip id={`downvote-${props.id}-tooltip`}>Not Helpful</Tooltip>}
        >
          <i className="fas fa-caret-down" onClick={onClickDownVote} style={style} />
        </OverlayTrigger>
      </Row>
    </Container>
  );

  function onClickUpVote() {
    props.voteClick(1);
  }

  function onClickDownVote() {
    props.voteClick(-1);
  }
}

VoteCounter.propTypes = {
  id: PropTypes.number.isRequired,
  voteClick: PropTypes.func.isRequired,
  voteCount: PropTypes.number.isRequired
};
